module.exports = __webpack_public_path__ + "static/img/qmwallet1_quit_cancel.22f327b8.png";